export default __webpack_public_path__ + "static/media/Icon-Toggle-Notification-Empty.b2a6c5b9.svg";